import { ChangeEvent, useEffect, useState } from 'react';
import styles from './AssessmentReport.module.css';
import { ICheckoutDetails } from '@/interfaces/IAssessmentData';
import { Input as InputText } from '../shared/ui/input/Input';
import { useAssessmentContext } from '@/libs/context/AssessmentContext';
import Image from 'next/image';
import { validationPattern } from '@/libs/constants/validationPatten';
export function AssessmentCheckoutForm() {
    const [activeForm, setActiveForm] = useState(false);
    const { getCityStateFromPincode, checkoutDetails, createJuspayLink } = useAssessmentContext();
    const [checkoutData, setCheckoutData] = useState<ICheckoutDetails>(checkoutDetails!);

    useEffect(() => {
        setCheckoutData({ ...checkoutData, city: checkoutDetails?.city || "", state: checkoutDetails?.state || "" })
    }, [checkoutDetails])

    const [errors, setErrors] = useState({
        "telephone": "",
        "first_name": "",
        "last_name": "",
        "pincode": "",
        "city": "",
        "landmark": "",
        "state": "",
        "address": ""
    });
    const States = [
        { value: "Andhra Pradesh", label: "Andhra Pradesh" },
        { value: "Andaman and Nicobar Islands", label: "Andaman and Nicobar Islands" },
        { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
        { value: "Assam", label: "Assam" },
        { value: "Bihar", label: "Bihar" },
        { value: "Chandigarh", label: "Chandigarh" },
        { value: "Chhattisgarh", label: "Chhattisgarh" },
        { value: "Dadar and Nagar Haveli", label: "Dadar and Nagar Haveli" },
        { value: "Daman and Diu", label: "Daman and Diu" },
        { value: "Delhi", label: "Delhi" },
        { value: "Lakshadweep", label: "Lakshadweep" },
        { value: "Puducherry", label: "Puducherry" },
        { value: "Goa", label: "Goa" },
        { value: "Gujarat", label: "Gujarat" },
        { value: "Haryana", label: "Haryana" },
        { value: "Himachal Pradesh", label: "Himachal Pradesh" },
        { value: "Jammu and Kashmir", label: "Jammu and Kashmir" },
        { value: "Jharkhand", label: "Jharkhand" },
        { value: "Karnataka", label: "Karnataka" },
        { value: "Kerala", label: "Kerala" },
        { value: "Madhya Pradesh", label: "Madhya Pradesh" },
        { value: "Maharashtra", label: "Maharashtra" },
        { value: "Manipur", label: "Manipur" },
        { value: "Meghalaya", label: "Meghalaya" },
        { value: "Mizoram", label: "Mizoram" },
        { value: "Nagaland", label: "Nagaland" },
        { value: "Odisha", label: "Odisha" },
        { value: "Punjab", label: "Punjab" },
        { value: "Rajasthan", label: "Rajasthan" },
        { value: "Sikkim", label: "Sikkim" },
        { value: "Tamil Nadu", label: "Tamil Nadu" },
        { value: "Telangana", label: "Telangana" },
        { value: "Tripura", label: "Tripura" },
        { value: "Uttar Pradesh", label: "Uttar Pradesh" },
        { value: "Uttarakhand", label: "Uttarakhand" },
        { value: "West Bengal", label: "West Bengal" }
    ];

    const handleChange = (e: ChangeEvent<HTMLInputElement> | any) => {
        const { name, value } = e.target;
        const isValid = isAllowed(name, value)
        if (isValid) {
            {
                setErrors({ ...errors, [name]: "" });
                setCheckoutData({ ...checkoutData, [name]: value });
            }
            if (name === 'pincode') {
                value.length === 6 && getCityStateFromPincode!(value)
            }
        }
    };

    const isAllowed = (name: string, value: string) => {
        const Character = new RegExp(validationPattern.Character);
        const Number = new RegExp(validationPattern.Number);
        switch (name) {
            case 'first_name':
            case 'last_name':
            case 'city':
                return (value === '' || (Character.test(value)))
            case 'telephone':
            case 'pincode':
                return (value === '' || (Number.test(value)))
            default:
                return true;
        }

    }
    const checkValidation = () => {
        const _errors = errors;
        let isValidate = true;
        if (!checkoutData.telephone || checkoutData.telephone.trim() == "") {
            _errors.telephone = "Mobile no is required";
            isValidate = false;
        } else if (checkoutData.telephone.length != 10) {
            _errors.telephone = "Please Enter a Valid Mobile No"
            isValidate = false;
        }
        else _errors.telephone = "";
        if (!checkoutData.first_name || checkoutData.first_name.trim() == "") {
            _errors.first_name = "First name is required";
            isValidate = false;
        }
        else
            _errors.first_name = "";
        if (!checkoutData.last_name || checkoutData.last_name.trim() == "") {
            _errors.last_name = "Last name is required";
            isValidate = false;
        }
        else
            _errors.last_name = "";
        if (!checkoutData.pincode || checkoutData.pincode.trim() == "") {
            _errors.pincode = "Pincode is required";
            isValidate = false;
        } else if (checkoutData.pincode.length != 6) {
            _errors.pincode = "Please Enter a Valid Pincode";
            isValidate = false;
        }
        else
            _errors.pincode = "";
        if (!checkoutData.city || checkoutData.city.trim() == "") {
            _errors.city = "City is required";
            isValidate = false;
        }
        else
            _errors.city = "";
        if (!checkoutData.landmark || checkoutData.landmark.trim() == "") {
            _errors.landmark = "Landmark is required";
            isValidate = false;
        }
        else
            _errors.state = "";
        if (!checkoutData.state || checkoutData.state.trim() == "") {
            _errors.state = "State is required";
            isValidate = false;
        }
        else
            _errors.state = "";
        if (!checkoutData.address || checkoutData.address.trim() == "") {
            _errors.address = "Address is required";
            isValidate = false;
        }
        else
            _errors.address = "";
        setErrors({ ..._errors });
        return isValidate;
    }
    useEffect(() => {
        const handleClick = (event: any) => {
            if (event.target.classList.contains('buyNowBtn')) {
                setActiveForm(true)
            }
        };
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);

    const submitData = async (e: any) => {
        e && e.preventDefault();
        if (checkValidation()) {
            createJuspayLink!(checkoutData);
        }
        else return;
    };

    return (<div className={`${styles.Shipping_warpper} ${activeForm && styles.Show_shipping} pb-20`}>
        <div className="">
            <div className={styles.shipping_payment}>
                <button className={styles.close_btn} onClick={() => setActiveForm(false)}>x <span>Close</span></button>
                <div className={`${styles.shipping_address} ${styles.full_width} backgroundf5f5f5`}>
                    <h2 className="font25 text333 mb30">Shipping Address</h2>
                    <div className={styles.form_warpper}>
                        <div className={styles.form_group}>
                            <InputText type="text" name="india" value="India" disabled />
                        </div>
                        <div className={`${styles.form_group} ${styles.countryCode} ${errors['telephone'] && styles.filled_required}`}>
                            <span>+91 </span><InputText type="tel" name="telephone" value={checkoutData.telephone} required={true} placeholder="Phone Number*" maxLength={10} onChange={handleChange} />
                            {errors['telephone'] && <p className={`font14 fontsm12 textff0000`}>
                                <Image width={14} height={14} src="/assets/images/required.svg" alt="required" style={{ marginRight: '8px' }} />
                                {errors['telephone']}
                            </p>}
                        </div>
                        <div className={`${styles.form_group} ${errors['first_name'] && styles.filled_required}`}>
                            <InputText type="text" name="first_name" placeholder="First Name*" value={checkoutData.first_name} required={true} onChange={handleChange} maxLength={50} />
                            {errors['first_name'] && <p className={`font14 fontsm12 textff0000`}>
                                <Image width={14} height={14} src="/assets/images/required.svg" alt="required" style={{ marginRight: '8px' }} />
                                {errors['first_name']}
                            </p>}
                        </div>
                        <div className={`${styles.form_group} ${errors['last_name'] && styles.filled_required}`}>
                            <InputText type="text" name="last_name" placeholder="Last Name" required={true} value={checkoutData.last_name} onChange={handleChange} maxLength={50} />
                            {errors['last_name'] && <p className={`font14 fontsm12 textff0000`}>
                                <Image width={14} height={14} src="/assets/images/required.svg" alt="required" style={{ marginRight: '8px' }} />
                                {errors['last_name']}
                            </p>}
                        </div>
                        <div className={`${styles.form_group} ${errors['pincode'] && styles.filled_required}`}>
                            <InputText type="tel" name="pincode" placeholder="Pin Code*" required={true} value={checkoutData.pincode} onChange={handleChange} maxLength={6} />
                            {errors['pincode'] && <p className={`font14 fontsm12 textff0000`}>
                                <Image width={14} height={14} src="/assets/images/required.svg" alt="required" style={{ marginRight: '8px' }} />
                                {errors['pincode']}
                            </p>}
                        </div>
                        <div className={`${styles.form_group} ${errors['city'] && styles.filled_required}`}>
                            <InputText type="text" name="city" placeholder="City*" required={true} value={checkoutData.city} onChange={handleChange} maxLength={40} />
                            {errors['city'] && <p className={`font14 fontsm12 textff0000`}>
                                <Image width={14} height={14} src="/assets/images/required.svg" alt="required" style={{ marginRight: '8px' }} />
                                {errors['city']}
                            </p>}
                        </div>
                        <div className={`${styles.form_group} ${errors['landmark'] && styles.filled_required}`}>
                            <InputText type="text" name="landmark" placeholder="Landmark" value={checkoutData.landmark} required={true} onChange={handleChange} maxLength={50} />
                            {errors['landmark'] && <p className={`font14 fontsm12 textff0000`}>
                                <Image width={14} height={14} src="/assets/images/required.svg" alt="required" style={{ marginRight: '8px' }} />
                                {errors['landmark']}
                            </p>}
                        </div>
                        <div className={`${styles.form_group} ${errors['state'] && styles.filled_required}`}>
                            <select name="state" id="state" className="form-control" onChange={handleChange} >
                                <option value="" defaultValue={""} >Select State *</option>
                                {States.map((f, idx) =>
                                    <option value={f.value} key={idx} selected={f.value === checkoutData.state}>{f.label}</option>
                                )}
                            </select>
                            {errors['state'] && <p className={`font14 fontsm12 textff0000`}>
                                <Image width={14} height={14} src="/assets/images/required.svg" alt="required" style={{ marginRight: '8px' }} />
                                {errors['state']}
                            </p>}
                        </div>
                        <div className={`${styles.form_group} ${styles.box12} ${errors['address'] && styles.filled_required}`}>
                            <InputText type="text" name="address" placeholder="Address*" value={checkoutData.address} required={true} onChange={handleChange} maxLength={500} />
                            {errors['address'] && <p className={`font14 fontsm12 textff0000`}>
                                <Image width={14} height={14} src="/assets/images/required.svg" alt="required" style={{ marginRight: '8px' }} />
                                {errors['address']}
                            </p>}
                        </div>
                        <div className={`${styles.form_group} ${styles.submit_button} ${styles.grid_items}`}>
                            <button className={`${styles.checkout} btn btn-primary ${styles.buy_now_btn}`} onClick={submitData}>Checkout Now</button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>)
}